<template>
    <main id="home-wrapper">
        <div v-if="loader" class="loading loading-double"></div>
        <div v-else id="homepage">
            <breadcrumb
                :breadcrumb="[
                    { title: 'Community', url: '/', status: false },
                    { title: 'Event', url: app_url + '/event', status: false },
                    {
                        title: event.name,
                        url: event.detail_url_web,
                        status: true
                    }
                ]"
            ></breadcrumb>

            <section id="headline-events" class="section withPad blackBg">
                <div class="container">
                    <div v-if="event">
                        <div class="event-headline" v-if="mobile">
                            <div v-if="event.type == 'hbd-nasional' && (payment_member && payment_member.status == 'PENDING' && showPurchaseButton)" class="row-notif-purchase">
                                <a @click="scrollToPurchase">⚠️ Pembayaran Anda belum selesai! Scroll ke bawah dan klik tombol "Selesaikan Pembayaran" untuk melanjutkan</a>
                            </div>
                            <div class="row-grid">
                                <div class="col-grid-50">
                                    <div class="img-promo-section-event">
                                        <img :src="event.image_ori" />
                                    </div>
                                </div>
                                <div class="col-grid-50">
                                    <div class="content-promo-section">
                                        <div class="title-promo">
                                            <h2 class="tx-black">
                                                {{ event.name }}
                                            </h2>
                                        </div>
                                        <div class="group_icon_detail">
                                            <div
                                                class="wrap-label flex flex-center"
                                            >
                                                <span
                                                    ><img
                                                        :src="
                                                            cdn_url +
                                                                '/assets/community/images/icon_calendar.png'
                                                        "
                                                        alt="calendar"
                                                /></span>
                                                <p class="tx-grey date-post">
                                                    {{ event.date_detail }}
                                                </p>
                                            </div>

                                            <div
                                                class="wrap-label flex flex-center"
                                            >
                                                <span
                                                    ><img
                                                        :src="
                                                            cdn_url +
                                                                '/assets/community/images/icon_place.png'
                                                        "
                                                        alt="calendar"
                                                /></span>
                                                <p class="tx-grey date-post">
                                                    {{ event.location }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="event-headline" v-else>
                            <div v-if="event.type == 'hbd-nasional' && (payment_member && payment_member.status == 'PENDING' && showPurchaseButton)" class="row-notif-purchase">
                                <a @click="scrollToPurchase">⚠️ Pembayaran Anda belum selesai! Scroll ke bawah dan klik tombol "Selesaikan Pembayaran" untuk melanjutkan</a>
                            </div>
                            <div class="row-grid">
                                <div class="col-grid-50 flex_align_center">
                                    <div class="content-promo-section">
                                        <div class="title-promo">
                                            <h2 class="tx-black">
                                                {{ event.name }}
                                            </h2>
                                        </div>
                                        <div class="group_icon_detail">
                                            <div
                                                class="wrap-label flex flex-center"
                                            >
                                                <span>
                                                    <img
                                                        :src="
                                                            cdn_url +
                                                                '/assets/community/images/icon_calendar.png'
                                                        "
                                                        alt="calendar"
                                                    />
                                                </span>
                                                <p class="tx-grey date-post">
                                                    {{ event.date_detail }}
                                                </p>
                                            </div>

                                            <div
                                                class="wrap-label flex flex-center"
                                            >
                                                <span>
                                                    <img
                                                        :src="
                                                            cdn_url +
                                                                '/assets/community/images/icon_place.png'
                                                        "
                                                        alt="calendar"
                                                    />
                                                </span>
                                                <p class="tx-grey date-post">
                                                    {{ event.location }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-grid-50">
                                    <div class="img-promo-section-event">
                                        <img :src="event.image_ori" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="row-middle-events" class="section bblack">
                <div class="container">
                    <div class="flex-beetwen">
                        <div class="btn-share" :class="{ active: show }">
                            <div class="shares" v-if="event">
                                <ShareNetwork
                                    network="facebook"
                                    :url="event.detail_url_web"
                                    :title="event.name"
                                    :description="event.description"
                                >
                                    <i class="ion-social-facebook"></i>
                                </ShareNetwork>
                                <ShareNetwork
                                    network="twitter"
                                    :url="event.detail_url_web"
                                    :title="event.name"
                                    :description="event.description"
                                >
                                    <i class="ion-social-twitter"></i>
                                </ShareNetwork>
                                <ShareNetwork
                                    network="whatsapp"
                                    :url="event.detail_url_web"
                                    :title="event.name"
                                    :description="event.description"
                                >
                                    <i class="ion-social-whatsapp"></i>
                                </ShareNetwork>
                            </div>
                            <div class="shares" v-else>
                                <a
                                    href="https://www.facebook.com/"
                                    target="_blank"
                                    ><i class="ion-social-facebook"></i
                                ></a>
                                <a href="http://twitter.com/" target="_blank"
                                    ><i class="ion-social-twitter"></i
                                ></a>
                                <a href="#" target="_blank"
                                    ><i class="ion-social-whatsapp"></i
                                ></a>
                            </div>
                            <a class="sharebtn" @click="showShare"
                                ><span
                                    ><i class="ion-android-share-alt"></i></span
                            ></a>
                        </div>
                        <div class="right-button" v-if="auth">
                            <div class="cta-product-box red_submit is-join-button" v-if="event.is_join">
                                <a
                                    v-if="event.type == 'hbd-nasional' && (payment_member && payment_member.status == 'PENDING' && showPurchaseButton)"
                                    id="btn-purchase"
                                    class="purchase-payment tx-white"
                                    @click="goToPaymentPurchase()"
                                    >Selesaikan Pembayaran ({{ minutes }}:{{
                                        seconds
                                    }})</a
                                >
                                <a class="joinEvent tx-white"
                                    >Anda Sudah Join</a
                                >
                            </div>
                            <div class="cta-product-box red_submit" v-else>
                                <div
                                    v-if="loaderJoin"
                                    class="loading loading-double"
                                ></div>
                                <a
                                    v-else
                                    @click="handleJoinEventClick(event)"
                                    class="joinEvent tx-white"
                                    >Join Event</a
                                >
                            </div>
                        </div>
                        <div v-else>
                            <div class="cta-product-box red_submit">
                                <a
                                    @click="trackerJoin(event)"
                                    class="joinEvent tx-white"
                                    :href="
                                        app_url +
                                            '/login?redirect=/event/' +
                                            event.slug +
                                            ''
                                    "
                                    >Join Event</a
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="teks-detail-events" class="section withPad bblack">
                <div class="container" v-if="event">
                    <div class="isi-event">
                        <h3>Tentang Event</h3>
                        <div v-html="event.description"></div>
                    </div>
                </div>
            </section>
        </div>
        <transition name="fade">
            <EventPopupHbd
                :event="event"
                v-show="isShowPopup"
                @close="closePopupRegis"
            />
        </transition>
        <transition name="fade">
            <EventPopupHbdPhone
                :event="event"
                v-show="isShowPopupPhone"
                @close="isShowPopupPhone = !isShowPopupPhone"
            />
        </transition>
        <transition name="fade">
            <EventConfirmationHbdNasionalPopup
                v-show="isShowPopupConfirmationHbdNasional"
                :event="event"
                @continue="handleContinueFromHbdNasionalPopup"
                @close="
                    isShowPopupConfirmationHbdNasional = !isShowPopupConfirmationHbdNasional
                "
            />
        </transition>
        <transition name="fade">
            <PaymentPopupConfirmation ref="paymentConfirmation" />
        </transition>
    </main>
</template>

<script>
import PaymentPopupConfirmation from "../payment/PaymentPopupConfirmation.vue";
import BreadCrumb from "../../widget/BreadCrumb";
import EventList from "../event/EventList";
import EventPopupHbd from "../event/EventPopupHbd.vue";
import EventPopupHbdPhone from "../event/EventPopupHbdPhone.vue";
import EventConfirmationHbdNasionalPopup from "../event/EventConfirmationHbdNasionalPopup.vue";
import { isMobile } from "mobile-device-detect";
import { encrypt } from "../../../lib/crypto";

export default {
    components: {
        breadcrumb: BreadCrumb,
        EventList,
        EventPopupHbd,
        EventPopupHbdPhone,
        EventConfirmationHbdNasionalPopup,
        PaymentPopupConfirmation
    },
    data() {
        return {
            isShowPopup: false,
            isShowPopupPhone: false,
            isShowPopupConfirmationHbdNasional: false,
            cdn_url: cdn_url,
            loaderJoin: false,
            loader: true,
            base_url: "",
            app_url: "",
            api_url: "",
            show: false,
            mobile: false,
            event: null,
            user: null,
            token: null,
            auth: auth,
            joinEventsClick: false,
            showerror: false,
            message: "Anda Belum Login",
            headers: null,
            currentpath: null,
            form: new Form({
                _token: token,
                event_id: "",
                schedule_id: ""
            }),
            payment_member: null,
            timeRemaining: 0,
            timer: 0,
            showPurchaseButton: false
        };
    },
    created() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.base_url = base_url;
        this.app_url = app_url;
        this.api_url = api_url;
        this.mobile = isMobile;
        this.getEventDetail();

        this.timer = setInterval(() => {
            if (this.timeRemaining > 0) {
                this.timeRemaining--;
            } else {
                clearInterval(this.timer); // Stop the timer when it reaches 0

                this.showPurchaseButton = false;
            }
        }, 1000);
    },
    computed: {
        minutes() {
            return Math.floor((this.timeRemaining % 3600) / 60);
        },
        seconds() {
            return this.timeRemaining % 60;
        }
    },
    mounted() {
        window.addEventListener("pageshow", function(event) {
            if (event.persisted) {
                // The page was loaded from the cache, so reload it mounted
                window.location.reload();
            }
        });
    },
    methods: {
        async checkPaymentType(event_id) {
            await axios
                .get(`${api_url}/member/event/check-payment-type/${event_id}`)
                .then(response => {
                    if (response.data.success) {
                        localStorage.setItem(
                            "event-hbd",
                            JSON.stringify(this.event)
                        );
                        this.$refs.paymentConfirmation.openPopup(
                            response.data
                        );
                    }
                })
                .catch(err => {
                    console.log('check type = ', err);
                });
        },
        checkUserSimulate(event_id) {
            const checkHcid = process.env.MIX_HCID_PAYMENT_TEST.split(",");
            const user = this.user.hcid;
            if (checkHcid.includes(user.toString())) {
                let checkPopup = localStorage.getItem("payment-confirmation-popup");
                if (checkPopup !== "close") {
                    this.checkPaymentType(event_id);
                }
            } else {
                console.log('simulate = ', false)
            }
        },
        closePopupRegis(event) {
            this.isShowPopup = !this.isShowPopup;
        },
        showShare() {
            this.show = !this.show;
        },
        trackerJoin(event) {
            var data = {
                event: "joinEvent",
                "eventDetail.category": "Join Event Community",
                "eventDetail.action": "Click Join Event Button",
                eventName: event.name, //Event Name
                id: event.id, //Event ID
                eventType: event.type, //Event Type
                startDate: event.start_date, //Event Start Date
                endDate: event.end_date, //Event End Date
                publishedDate: event.created_at, //Event Created Date
                province: event.province //Event Province
            };
            // console.log(data);
            dataLayer.push(data);
        },
        handleJoinEventClick(event) {
            if (event.type === "hbd-nasional") {
                this.isShowPopupConfirmationHbdNasional = true;
                this.trackerJoin(event, "Click Join Event Button");
                this.trackerConfirmationJoinEvent(
                    event,
                    "Notif Verification Join Event"
                );
            } else {
                this.trackerJoin(event, "Click Join Event Button");
                this.joinEvent(event);
            }
        },
        handleContinueFromHbdNasionalPopup() {
            this.isShowPopupConfirmationHbdNasional = false;
            this.joinEvent(this.event);
        },
        joinEvent(event) {
            localStorage.removeItem("event-attend-hbd");
            // this.trackerJoin(event, 'Click Join Event Button');
            if (event.is_hbd) {
                let newUrl = `/registration-hbd`;
                localStorage.removeItem("payment-event");
                this.checkVerified(event); // Check number verified or not
            } else {
                this.loaderJoin = true;
                this.form
                    .post(api_url + "/member/event/join")
                    .then(response => {
                        this.loaderJoin = false;
                        this.event.is_join = true;
                        console.log(response);
                    })
                    .catch(err => {
                        console.log(err);
                        this.loaderJoin = false;
                        localStorage.clear();
                        window.location.href = app_url + "/login";
                    });
            }
        },
        async checkVerified(event) {
            try {
                await axios
                    .get(`${api_url}/member/check-verified-phone`)
                    .then(response => {
                        const data = response.data;
                        localStorage.setItem(
                            "event-hbd",
                            JSON.stringify(this.event)
                        );
                        if (data.verified) {
                            localStorage.setItem("openpopup-regis-nopol", true);
                            this.isShowPopup = !this.isShowPopup;
                            let data = {
                                event: "updateInformation",
                                "eventDetail.category":
                                    "Update Information HCID",
                                "eventDetail.action": "Notif Input Nopol",
                                eventName: event.name, //Event Name
                                id: event.id, //Event ID
                                eventType: event.type, //Event Type
                                startDate: event.start_date, //Event Start Date
                                endDate: event.end_date, //Event End Date
                                publishedDate: event.created_at, //Event Created Date
                                province: event.province //Event Province
                            };
                            // console.log(data, 'Notif Input Nopol');
                            dataLayer.push(data); // Datalayer Notif Input Nopol
                        } else {
                            localStorage.setItem("openpopup-regis-phone", true);
                            this.isShowPopupPhone = !this.isShowPopupPhone;
                            let data = {
                                event: "updateInformation",
                                "eventDetail.category":
                                    "Update Information HCID",
                                "eventDetail.action":
                                    "Notif Input Phone Number",
                                eventName: event.name, //Event Name
                                id: event.id, //Event ID
                                eventType: event.type, //Event Type
                                startDate: event.start_date, //Event Start Date
                                endDate: event.end_date, //Event End Date
                                publishedDate: event.created_at, //Event Created Date
                                province: event.province //Event Province
                            };
                            // console.log(data, 'Notif Input Phone Number');
                            dataLayer.push(data); // Notif Input Phone Number
                        }
                    });
            } catch (error) {
                console.log(error);
            }
        },
        getEventDetail() {
            axios
                .get(
                    api_url + "/event-detail/" + this.$route.params.slug,
                    this.headers
                )
                .then(response => {
                    this.event = response.data.data.eventDetail;
                    this.form.event_id = this.event.id;
                    this.loader = false;

                    if (this.event.type === "hbd-nasional") {
                        this.getPaymentMember();
                        // this.checkUserSimulate(this.event.id);
                        let checkPopup = localStorage.getItem("payment-confirmation-popup");
                        if (checkPopup !== "close") {
                            this.checkPaymentType(this.event.id);
                        }
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getPaymentMember() {
            axios
                .get(
                    `${api_url}/member/event/get-payment-member/${this.$route.params.slug}`,
                    this.headers
                )
                .then(response => {
                    if (response.data.status == true) {
                        this.payment_member = response.data.data;

                        if (this.payment_member.status == "PENDING") {
                            this.calculateTimeRemaining(
                                this.payment_member.expired_at
                            );
                            this.showPurchaseButton = true;
                        }
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        },
        async goToPaymentPurchase() {
            await axios
                .get(
                    `${api_url}/member/event/go-to-payment/${this.$route.params.slug}`,
                    this.headers
                )
                .then(async response => {
                    if (response.data.status) {
                        if (this.payment_member) {
                            if (localStorage.getItem("event-hbd") == null) {
                                localStorage.setItem(
                                    "event-hbd",
                                    JSON.stringify(this.event)
                                );
                            }
                            if (localStorage.getItem("payment-event") == null) {
                                localStorage.setItem("payment-event", true);
                            }
                            if (
                                localStorage.getItem("update-police-number") ==
                                null
                            ) {
                                localStorage.setItem(
                                    "update-police-number",
                                    true
                                );
                            }
                            if (
                                localStorage.getItem("event-attend-hbd") == null
                            ) {
                                const encryptDataEventAttend = await this.handleEncrypt(
                                    JSON.stringify(
                                        response.data.data.event_attend
                                    )
                                );
                                localStorage.setItem(
                                    "event-attend-hbd",
                                    encryptDataEventAttend
                                );
                            }
                            if (
                                localStorage.getItem("transaction-hbd") == null
                            ) {
                                const encryptDataPayment = await this.handleEncrypt(
                                    JSON.stringify(response.data.data.payment)
                                );
                                localStorage.setItem(
                                    "transaction-hbd",
                                    encryptDataPayment
                                );
                            }

                            switch (this.payment_member.payment_type) {
                                case "virtual_account":
                                    window.location.href = `${this.event.detail_url_web}/payment/virtual-account`;
                                    break;
                                case "ewallet":
                                    let redirectLink = null;
                                    let actionLink = this.payment_member
                                        .payment_detail;
                                    if (actionLink.mobile_deeplink_checkout_url)
                                        redirectLink =
                                            actionLink.desktop_web_checkout_url;
                                    else if (actionLink.mobile_web_checkout_url)
                                        redirectLink =
                                            actionLink.mobile_web_checkout_url;
                                    else
                                        redirectLink =
                                            actionLink.desktop_web_checkout_url;
                                    window.location.href = redirectLink;
                                    break;
                                case "qris":
                                    window.location.href = `${this.event.detail_url_web}/payment/qris`;
                                    break;
                                case "retail_outlet":
                                    window.location.href = `${this.event.detail_url_web}/payment/retail-outlet`;
                                    break;
                                default:
                                    window.location.href = `${this.event.detail_url_web}/thank-you`;
                                    break;
                            }
                        }
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        },
        trackerConfirmationJoinEvent(event, action) {
            let data = {
                event: "joinEvent",
                "eventDetail.category": "Join Event Community",
                "eventDetail.action": action,
                eventName: event.name,
                id: event.id,
                eventType: event.type,
                startDate: event.start_date,
                endDate: event.end_date,
                publishedDate: event.created_at,
                province: event.province
            };
            // console.log('joinEvent tracker popup = ', data)
            dataLayer.push(data);
        },
        calculateTimeRemaining(expired_at) {
            const now = new Date().getTime(); // Waktu saat ini dalam milidetik
            const expiredTime = new Date(expired_at).getTime(); // Convert expired_at ke milidetik
            const diff = expiredTime - now; // Selisih waktu dalam milidetik
            this.timeRemaining = Math.floor(diff / 1000); // Convert ke detik
        },
        async handleEncrypt(input) {
            try {
                const encryptText = await encrypt(
                    input,
                    process.env.MIX_ENCODED_SECRET_KEY
                );
                return encryptText;
            } catch (error) {
                console.log(error);
                return false;
            }
        },
        scrollToPurchase() {
            const purchaseButton = document.getElementById("btn-purchase");

            if (purchaseButton) {
                purchaseButton.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                });
            }
        }
    }
};
</script>

<style scoped lang="scss">
.row-notif-purchase {
    background: white;
    color: #e61b33;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;

    a {
        font-weight: bold;
        font-size: 18px;
        text-decoration: none;
    }

    &:hover {
        text-decoration: underline;
    }
}

.bblack {
    background: #161616;
}

.joinEvent:hover {
    color: #fff;
    border: solid 1px #000;
    background: #333;
    text-decoration: none;
}

.joinEvent {
    cursor: pointer;
}

.purchase-payment {
    background-color: white !important;
    color: #e61b33;
    border: 1px solid #dbdbdb;
    padding: 10px 20px;
    border-radius: 10px;
    font-weight: 700;
    font-size: 14px;
    display: inline-block;
    cursor: pointer;
}

.img-promo-section-event {
    border-radius: 0px;
    float: right;
    overflow: hidden;

    img {
        max-width: 100%;
    }
}

.content-promo-section {
    padding-right: 120px;
    padding-left: 40px;
}

.wrap-label {
    justify-content: start;
}

.wrap-label span {
    font-size: 12px;
    font-weight: 500;
    display: inline-block;
    margin-right: 10px;
}

.date-news span,
.date-news p {
    display: inline-block;
}

.date-news span {
    font-size: 15px;
    margin-right: 5px;
}

.title-promo {
    margin-bottom: 20px;

    h2 {
        margin-top: 0;
        color: #fff;
        margin-bottom: 20px;
    }

    p {
        margin: 0;
        line-height: 24px;
        color: #8e8e8e;
    }
}

.btn-share {
    position: relative;
}

.btn-share a {
    margin-top: 0;
    border-radius: 100px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    width: 35px;
    height: 35px;
    line-height: 35px;
    text-align: center;
    display: inline-block;
    cursor: pointer;
    color: #fff;
    background-color: transparent;
}

.btn-share a:hover {
    background-color: #e61b33;
    color: #fff;
}

.active .shares {
    width: 150px;
    left: 42px;
}

.active .shares {
    width: 150px;
}

.active .sharebtn {
    color: #999;
    background-color: #f2f2f2;
}

.shares {
    position: absolute;
    bottom: 0;
    left: 35px;
    height: 35px;
    width: 0;
    overflow: hidden;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;

    a {
        margin: 0 4px;
    }
}

.offset-section {
    padding-left: 7em;
}

.list-logo .row-grid {
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
}

.group_icon_detail .wrap-label p {
    margin: 0;
}

#headline-events .col-grid-50.flex_align_center {
    display: flex;
    flex: 1;
    align-items: center;
}

#row-middle-events {
    padding-top: 20px;
    padding-bottom: 20px;
    border-top: 1px solid rgba(219, 219, 219, 0.1);
    border-bottom: 1px solid rgba(219, 219, 219, 0.1);
}

.flex-beetwen {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.isi-event h3 {
    font-weight: bold;
    font-size: 20px;
    color: #ffffff;
}

.isi-event p {
    font-weight: 300;
    font-size: 15px;
    color: #b4b4b4;
}

.schedule-list {
    display: flex;
    align-items: center;
    color: #fff;
    padding: 30px 0;
    border-bottom: solid 1px #333;

    h3 {
        font-size: 20px;
    }

    .right-button {
        margin-left: auto;
    }
}

.schedule-list:last-child {
    border: none;
}

@media all and (max-width: 767px) {
    .title_headline h3,
    .title-promo h2 {
        font-size: 24px;
    }

    img-promo-section-event {
        margin-bottom: 25px;
    }

    .content-promo-section {
        padding-right: 5px;
        padding-left: 5px;
        margin-bottom: 15px;
    }

    .title-promo {
        margin-top: 20px;
    }

    .row-notif-purchase {
        a {
            font-weight: bold;
            font-size: 13px;
        }
    }

    .purchase-payment {
        margin-bottom: 8px;
    }

    .is-join-button {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;
    }
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 200ms ease-out;
}
</style>
